import {
  DatiSessioneUtente,
  EnumDatiAnagraficiAggiuntiviMetodoLoginUtilizzato,
  EnumModuloDTONecessitaFirma,
  RichiestaDTO,
} from '@framework/api-client';
import { IFrontOfficeModule } from '@framework/frontoffice-submission';
import { SubmissionModuleState } from '../../module/fsm/SubmissionModuleState';

export class SubmissionModuleLogic {
  static getState(module: IFrontOfficeModule): SubmissionModuleState {
    return module.stato ?? SubmissionModuleState.None;
  }

  /**
   * Ritorna vero se la firma è necessaria per il modulo
   */
  static needSign(
    module: IFrontOfficeModule,
    submission: RichiestaDTO,
    user: DatiSessioneUtente | null | undefined,
  ) {
    // Controllo se la firma è richiesta dalla configurazione del modulo
    // TODO Gestire override domandaModulo (submissionModule.domandaModulo.necessitaFirma)
    if (module?.necessitaFirma === EnumModuloDTONecessitaFirma.NO) {
      return false;
    }

    // Se l'utente è autenticato con un sistema terzo (SPID/CIE/CNS/eIDAS/LDAP) la firma non è richiesta
    // Mentre se l'utente è autenticato come EXTRA_UE (username+password) la firma è richiesta
    // Se il flag necessitaFirmaSempre è attivo, la firma è richiesta sempre indipendentemente dal metodo di login
    const userLoginMethod =
      user?.utenteLoggato?.datiAnagraficiAggiuntivi?.metodoLoginUtilizzato;
    if (
      !module?.necessitaFirmaSempre &&
      userLoginMethod &&
      userLoginMethod !==
        EnumDatiAnagraficiAggiuntiviMetodoLoginUtilizzato.EXTRA_UE
    ) {
      return false;
    }

    // Controllo se la firma è richiesta solo per un Delegato
    if (
      module?.necessitaFirma === EnumModuloDTONecessitaFirma.SI_SE_NON_TITOLARE
    ) {
      // La firma è richiesta solo se l'utente loggato non è tra i titolari
      return !submission.datiTitolari?.some(
        t => t.idUtente === user?.utenteLoggato?.idUtente,
      );
    }

    return true;
  }
}
